import { Util } from '@/util/Util';
export class User {
    constructor() {
        this.name = '';
        this.password = '';
        this.userId = -1;
    }
    fromObject(source) {
        Util.deepCopy(source, this);
        return this;
    }
    getCopy() {
        return {
            name: this.name,
            userId: this.userId,
            password: this.password,
        };
    }
}
//# sourceMappingURL=User.js.map